import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-deleted',
  template: `
    <div *ngIf="activity.deletedType !== 'deal'">
    <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
      <mat-icon>delete</mat-icon>
    </div>
      <div class="description">
        <strong>{{ activity.meta['deletedType'] }}
          <span *ngIf="activity.meta['deletedType'] !== 'call' && activity.meta['deletedType'] !== 'reminder'
          && activity.meta['deletedType'] !== 'appointment'">
            Deleted
          </span>
          <span *ngIf="activity.meta['deletedType'] === 'call' || activity.meta['deletedType'] === 'reminder'
          || activity.meta['deletedType'] === 'appointment'">
            Canceled
          </span>
        </strong>
        <span class="text" *ngIf="activity.meta['deletedBy'] === 'borrower' && borrower.primary_contact">
        by {{ borrower.primary_contact.first }} {{ borrower.primary_contact.last }}.
       </span>
       <span class="text" *ngIf="activity.meta['deletedBy'] !== 'borrower'">by {{ activity.meta['lenderUserName'] }}</span>
       <span>
        <document-pill
         class="ml-2"
         [filename]="activity.meta['filename']"
         [bytes]="activity.meta['size']"
        ></document-pill>
       </span>
      </div>
      <!-- description -->
    </div> <!-- activity-created -->

    <div *ngIf="activity.meta['deletedType'] === 'deal'">
      <div class="icon">
        <i class="icon-20-bell-removed"></i>
      </div>
      <div class="description">
        <strong>Deal Removed</strong> {{ activity.meta['lenderUserName'] }} removed a deal.
      </div>
    </div>
    `,
  styles: ['.description strong { text-transform: capitalize; }']
})
export class ActivityRowDeletedComponent {
  @Input() activity;
  @Input() borrower;
}
